import fetch from '@/common/fetch';
import { apiName } from '@/api/index';

const path = `${apiName}/public`;

// annoucement_list
const annoucementlist = `api/v1/News/EastNews`;
const lastlist = `api/v1/News/last`;
const Calendarlist = `api/v1/News/Calendar`;
// signin
const signinurl = `${path}/signin`;
// 上传图片
const upload_imageurl = `${path}/upload_image`;
// 合作伙伴
const partnerapply_url = `${path}/partnerapply`;


const getannoucementlist = data => (fetch({
  url: annoucementlist,
  method: 'post',
  data,
}));
const getaCalendarlist = data => (fetch({
  url: Calendarlist,
  method: 'post',
  data,
}));
const getlastlist = data => (fetch({
  url: lastlist,
  method: 'post',
  data,
}));
const signin = data => (fetch({
  url: signinurl,
  method: 'post',
  data,
}));
const sendImg = data => (fetch({
  url: upload_imageurl,
  method: 'post',
  data,
}));
const addPartnerapply = data => (fetch({
  url: partnerapply_url,
  method: 'post',
  data,
}));



export default {
  getaCalendarlist,
  getannoucementlist,
  signin,
  sendImg,
  getlastlist,
  addPartnerapply,
};



// WEBPACK FOOTER //
// ./src/api/public/index.js